import { getIdOrNull, isObject } from '../../../../utils'

export const buildSectionToYearQuota = (quota, coloredSectionToYears) => {
  if (getIdOrNull(quota.sectionToYear)) {
    const sty = coloredSectionToYears.find(isQuotaInSectionToYear(quota))

    if (isObject(sty) && sty.color) {
      quota.sectionToYear.color = sty.color
    }
  }

  return quota
}

export const buildSchoolQuota = (quota, coloredSchools) => {
  if (isObject(quota.school)) {
    const school = coloredSchools.find(isQuotaInSchool(quota))

    if (isObject(school) && school.color) {
      quota.school.color = school.color
    }
  }

  return quota
}

export const isQuotaInSectionToYear = quota => sectionToYear => sectionToYear.id === quota.sectionToYear.id
export const isQuotaInSchool = quota => school => school.id === quota.school.id
export const isQuotaInSchools = schools => quota => schools.some(isQuotaInSchool(quota))
export const isQuotaInSectionToYears = sectionToYears => quota => isObject(quota.sectionToYear) ? sectionToYears.some(isQuotaInSectionToYear(quota)) : false
